import {
  registerV2 as publicRegisterV2,
  validateEmail as publicValidateEmail,
  loginV2 as publicLoginV2,
  changePassword as publicChangePassword,
  signOn as publicSignOn,
  logout as publicLogout,
} from './iam-authentication-v1-authentication-authentication.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const registerV2: MaybeContext<
  BuildRESTFunction<typeof publicRegisterV2> & typeof publicRegisterV2
> = /*#__PURE__*/ createRESTModule(publicRegisterV2);
export const validateEmail: MaybeContext<
  BuildRESTFunction<typeof publicValidateEmail> & typeof publicValidateEmail
> = /*#__PURE__*/ createRESTModule(publicValidateEmail);
export const loginV2: MaybeContext<
  BuildRESTFunction<typeof publicLoginV2> & typeof publicLoginV2
> = /*#__PURE__*/ createRESTModule(publicLoginV2);
export const changePassword: MaybeContext<
  BuildRESTFunction<typeof publicChangePassword> & typeof publicChangePassword
> = /*#__PURE__*/ createRESTModule(publicChangePassword);
export const signOn: MaybeContext<
  BuildRESTFunction<typeof publicSignOn> & typeof publicSignOn
> = /*#__PURE__*/ createRESTModule(publicSignOn);
export const logout: MaybeContext<
  BuildRESTFunction<typeof publicLogout> & typeof publicLogout
> = /*#__PURE__*/ createRESTModule(publicLogout);

export {
  CaptchaFlow,
  CaptchaIdentityType,
  CaptchaOutcome,
  CaptchaKind,
  CaptchaResult,
  CaptchaDecisionReason,
  PrivacyStatus,
  EmailTag,
  PhoneTag,
  AddressTag,
  FactorType,
  StateType,
  StatusName,
  V1Reason,
  Status,
  FactorStatus,
  MfaReason,
  Reason,
  TenantType,
  DeliveryMethod,
  WebhookIdentityType,
} from './iam-authentication-v1-authentication-authentication.universal.js';
export {
  Authentication,
  CaptchaVerification,
  RegisterV2Request,
  LoginId,
  LoginIdTypeOneOf,
  IdentityProfile,
  CustomField,
  V1CustomValue,
  V1CustomValueValueOneOf,
  V1ListValue,
  V1MapValue,
  SecondaryEmail,
  Phone,
  AddressWrapper,
  Address,
  CaptchaToken,
  CaptchaTokenTokenOneOf,
  RecaptchaForClientSiteKey,
  StateMachineResponse,
  StateMachineResponseStateDataOneOf,
  Identity,
  Connection,
  ConnectionTypeOneOf,
  IdpConnection,
  AuthenticatorConnection,
  Metadata,
  Email,
  StatusV2,
  Factor,
  CustomValue,
  CustomValueValueOneOf,
  ListValue,
  MapValue,
  RequireMfaData,
  V1Factor,
  MfaChallengeData,
  VerificationChallenge,
  VerificationChallengeFactorChallengeDataOneOf,
  PushChallengeData,
  WebAuthnChallengeData,
  RequireFirstFactorData,
  ValidateEmailRequest,
  ValidateEmailResponse,
  EmailValidationFailure,
  LoginV2Request,
  WebAuthnVerifyData,
  ChangePasswordRequest,
  ChangePasswordResponse,
  LoginWithIdpConnectionRequest,
  RawHttpResponse,
  HeadersEntry,
  RawHttpRequest,
  PathParametersEntry,
  QueryParametersEntry,
  LoginWithIdpConnectionRedirectRequest,
  ConnectIdpRequest,
  LoginCallbackRequest,
  LoginWithIdpConnectionTokenParamsRequest,
  SignOnRequest,
  SignOnResponse,
  LogoutRequest,
  VerifyRequest,
  VerifyRequestFactorDataOneOf,
  SmsVerifyData,
  CallVerifyData,
  ExternalEmailVerifyData,
  TotpVerifyData,
  PushVerifyData,
  RecoveryCodeVerifyData,
  GetWebauthnChallengeRequest,
  GetWebauthnChallengeResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  RegisterV2Options,
  LoginV2Options,
  SignOnOptions,
  LogoutOptions,
} from './iam-authentication-v1-authentication-authentication.universal.js';
export {
  CaptchaFlowWithLiterals,
  CaptchaIdentityTypeWithLiterals,
  CaptchaOutcomeWithLiterals,
  CaptchaKindWithLiterals,
  CaptchaResultWithLiterals,
  CaptchaDecisionReasonWithLiterals,
  PrivacyStatusWithLiterals,
  EmailTagWithLiterals,
  PhoneTagWithLiterals,
  AddressTagWithLiterals,
  FactorTypeWithLiterals,
  StateTypeWithLiterals,
  StatusNameWithLiterals,
  V1ReasonWithLiterals,
  StatusWithLiterals,
  FactorStatusWithLiterals,
  MfaReasonWithLiterals,
  ReasonWithLiterals,
  TenantTypeWithLiterals,
  DeliveryMethodWithLiterals,
  WebhookIdentityTypeWithLiterals,
  RegisterV2ApplicationErrors,
  RegisterV2ValidationErrors,
  LoginV2ApplicationErrors,
  LoginV2ValidationErrors,
} from './iam-authentication-v1-authentication-authentication.universal.js';
